import React from 'react';
import { connect } from 'react-redux';
import { Navbar } from 'reactstrap';

function Header({ logo, className, id = 'header', style }) {
  return (
    <Navbar
      id={id}
      style={style}
      className={[
        'd-flex justify-content-start align-items-center border-bottom border-light',
        'bg-white shadow-sm w-100 px-3 py-1 sticky-top',
        // Prevent header from being printed on .print()
        'd-print-none',
        className,
      ].join(' ')}
    >
      <div>
        {logo
          ? (
            <img
              src={logo}
              alt="logo"
              className="me-2"
              style={{ height: '40px' }}
            />
          )
          : null}
      </div>
    </Navbar>
  );
}

const mapStateToProps = (store) => ({
  logo: store.theme.logo,
});

export default connect(mapStateToProps)(Header);
